import axios from "axios"

import { VUE_APP_API } from "@/constants/constants"

const service = axios.create({
    baseURL: VUE_APP_API,
    // timeout: 30000,
})

// request interceptors
service.interceptors.request.use(
    config => {
        // console.log('Starting Request', config);
        return config
    },
    error => {
        console.error('Request Error', error)

        return Promise.reject(error)
    },
)

// response interceptors
service.interceptors.response.use(
    response => {
        if (response.status === 200) {
            // console.log('Response:', response);
            return response.data
        } else {
            return Promise.reject(response)
        }
    },
    error => {
        console.error('Response Error', error)

        return Promise.reject(error)
    },
)

export default service